import { render, staticRenderFns } from "./questionnaireSurvey.vue?vue&type=template&id=48a133c7"
import script from "./questionnaireSurvey.vue?vue&type=script&lang=js"
export * from "./questionnaireSurvey.vue?vue&type=script&lang=js"
import style0 from "./questionnaireSurvey.vue?vue&type=style&index=0&id=48a133c7&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports